import Sar from "@/assets/images/Sar";
import { CurrencySymbol } from "@/components/molecules/CurrencySymbol";

import { formatNumber } from "./formatNumber";
import { formatPrice } from "./formatPrice";

/** What `renderMoneyValue` needs to draw an amount in a currency other than SAR. */
export interface MoneyCurrency {
  code?: string;
  symbol?: string;
  decimals?: number;
}

/**
 * Draws an amount with its currency symbol.
 *
 * Without `currency` it draws the SAR sign and the value as given, as before.
 * With one, it draws that currency's symbol and writes the value with the
 * currency's decimals (`100.5` becomes `100.500` in JOD).
 */
export const renderMoneyValue = (
  value: string | undefined,
  prefix = "",
  isFormatting = false,
  currency?: MoneyCurrency
) => {
  if (value === "" || value === null || value === undefined) {
    return <span>-</span>;
  }

  let formatValue = value;

  if (isFormatting) {
    formatValue = formatNumber(
      Number(value),
      undefined,
      currency?.decimals
    ) as string;
  } else if (currency?.decimals !== undefined) {
    formatValue = formatPrice(value, currency.decimals) || value;
  }

  return (
    <div className="flex items-center">
      {prefix && <span>{prefix}</span>}
      {currency?.code ? (
        <CurrencySymbol
          code={currency.code}
          symbol={currency.symbol}
          classes="h-2.5"
        />
      ) : (
        <Sar classes="h-2.5" />
      )}
      <span>{formatValue}</span>
    </div>
  );
};
